import i18n, { Ti18nKeys } from "../../constants/i18n";
import Et3Collapsible from "../et3-collapsible";
import ET3Div from "../et3-div";
import { withLiteObserverAndTheme } from "../et3-enhanced-render";
import {
  SURFACE_BORDER,
  SURFACE_RADIUS_CSS,
  SURFACE_SHADOW
} from "../et3-theme/surface-constants";
import SectionHeader from "./SectionHeader";
import {
  SECTION_BODY_PADDING,
  SECTION_HEADER_HEIGHT
} from "./section-constants";

const Et3Section = withLiteObserverAndTheme<{
  children?: React.ReactNode;
  titleKey: Ti18nKeys;
  summary: string;
  count: number;
  sectionId: string;
  defaultOpen: boolean;
}>((props) => {
  const {
    children = null,
    titleKey,
    summary,
    count,
    sectionId,
    defaultOpen,
    theme
  } = props;
  const { colors, unitX, unitY } = theme;

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={true}
      withShadow={false}
      width={0}
      height={SECTION_HEADER_HEIGHT}
      fDirection="column"
      alignItems="stretch"
      justifyContent="flex-start"
      color={colors.all.white}
      style={{
        boxSizing: "border-box",
        width: "100%",
        minWidth: 0,
        border: SURFACE_BORDER,
        borderRadius: SURFACE_RADIUS_CSS,
        boxShadow: SURFACE_SHADOW,
        overflow: "hidden"
      }}
      onClick={() => {}}
    >
      <SectionHeader
        title={i18n.get(titleKey)}
        summary={summary}
        count={count}
        sectionId={sectionId}
        defaultOpen={defaultOpen}
        isCollapsible={true}
        width={0}
      />
      <Et3Collapsible sectionId={sectionId} defaultOpen={defaultOpen}>
        <ET3Div
          isScrollable={false}
          isExtendable={true}
          withShadow={false}
          width={0}
          height={0}
          fDirection="column"
          alignItems="stretch"
          justifyContent="flex-start"
          color={colors.all.white}
          style={{
            boxSizing: "border-box",
            width: "100%",
            padding: `${SECTION_BODY_PADDING * unitY}px ${
              SECTION_BODY_PADDING * unitX
            }px`
          }}
          onClick={() => {}}
        >
          {children}
        </ET3Div>
      </Et3Collapsible>
    </ET3Div>
  );
});
export default Et3Section;
